var HorizontalProgrammeScroll = function(){

  var currentClick;
  var maxClicks;
  var columnWidth;
  var buttonLeft;
  var buttonRight;
  var contentWrap;
  var offset;

  var _init = function(){
    currentClick = 0;
    offset = 0 ;
    maxClicks = document.getElementsByClassName('l-program__headerItem').length / 2;
    buttonLeft = document.getElementById('scroll-program-left');
    buttonRight = document.getElementById('scroll-program-right');
    contentWrap = document.getElementsByClassName('l-program__headerProgramWrap')[0];

    _getColumnWidth();
    _addListeners()

    window.addEventListener('resize', _getColumnWidth);
    
  };

  var _addListeners = function(){
    buttonRight.addEventListener('click', _scrollRight);
    buttonLeft.addEventListener('click', _scrollLeft);
  }

  var _scrollLeft = function(){
    contentWrap.scrollLeft += -columnWidth;
  };

  var _scrollRight = function(e){
    
    contentWrap.scrollLeft += columnWidth;
  };  


  var _getColumnWidth = function(){
    columnWidth = document.getElementsByClassName('l-program__headerItem')[0].clientWidth;
  }

  return{
    init: _init
  }
}();

if (document.getElementsByClassName('m-program-scroll')) {
  HorizontalProgrammeScroll.init();
}


// WEBPACK FOOTER //
// ./resources/assets/js/partials/HorizontalProgrammeScroll.js